const config = {
  rowSelection: false,
  columns: [
    {
      title: '转款单号',
      dataIndex: 'billNo',
      width: 180,
      render: "IdRender",
    },
    {
      title: '转款时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 180
    },
    {
      title: '转款金额',
      dataIndex: 'transferOutAmount',
      width: 140
    },
    {
      title: '转款类型',
      dataIndex: 'transferTypeName',
      width: 160
    },
    {
      title: '转出交易类型',
      dataIndex: 'transferOutTransactionTypeName',
      width: 160
    },
    {
      title: '转入交易类型',
      dataIndex: 'transferInTransactionTypeName',
      width: 160
    },
    {
      title: '转出原因',
      dataIndex: 'transferReason',
      ellipsis: true,
      width: 260
    },
  ],
  search: [],
  footer: []
}
export default config
